import ResourceLoaderProto from 'src/core/core3-depricated/app/resource-loader-proto';

const appLoaderFunction = () => import(/* webpackChunkName: "task-view" */ './app.js');

module.exports = class SharedViewTaskViewAppLoader extends ResourceLoaderProto {

    constructor(appParams) {
        super(appParams);

        this.domElementId = appParams.containerId;
    }

    resources() {
        return [
            this._loadCSS('task'),
            this._loadAPP(appLoaderFunction)
        ];
    }
};
